// LoginGate.jsx — Public-facing sign-in card. The only chunk visible to
// unauthenticated visitors.

import React from "react";
import { isFirebaseConfigured, signInWithGoogle } from "./firebaseClient.ts";

export function LoginGate({ error }) {
  const [busy, setBusy] = React.useState(false);
  const [signInError, setSignInError] = React.useState(null);

  const handleSignIn = async () => {
    setBusy(true);
    setSignInError(null);
    try {
      await signInWithGoogle();
    } catch (e) {
      setSignInError(e?.message ?? String(e));
    } finally {
      setBusy(false);
    }
  };

  const configured = isFirebaseConfigured();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #10213A 0%, #0A1627 100%)",
        padding: 24,
      }}
    >
      <div
        style={{
          width: 380,
          maxWidth: "100%",
          background: "#15263F",
          borderRadius: 18,
          boxShadow:
            "0 30px 80px rgba(0,0,0,0.6), inset 0 0 0 1px rgba(255,255,255,0.06)",
          padding: 32,
          color: "#fff",
          fontFamily: "var(--as-font-sans)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 24,
          }}
        >
          <div
            className="bo-logo-glow"
            style={{
              width: 36,
              height: 36,
              borderRadius: 9,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src="/assets/logo-A.svg"
              alt="Archery Spot"
              width={24}
              height={24}
              style={{ filter: "invert(1) brightness(1.1)" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}>
            <span style={{ fontSize: 16, fontWeight: 600 }}>Archery Spot</span>
            <span
              style={{
                fontSize: 11,
                color: "rgba(255,255,255,0.55)",
                textTransform: "uppercase",
                letterSpacing: 0.12,
              }}
            >
              Back office
            </span>
          </div>
        </div>

        <div style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.5, color: "rgba(255,255,255,0.75)" }}>
          Sign in with an authorized Google account to continue.
        </div>

        {!configured && (
          <div
            style={{
              marginBottom: 16,
              padding: "10px 12px",
              borderRadius: 10,
              background: "rgba(255,15,0,0.10)",
              boxShadow: "inset 0 0 0 1px rgba(255,80,80,0.40)",
              color: "#FFB0AB",
              fontSize: 12.5,
            }}
          >
            Firebase config missing. Set VITE_FIREBASE_API_KEY,
            VITE_FIREBASE_AUTH_DOMAIN, VITE_FIREBASE_PROJECT_ID at build time.
          </div>
        )}

        <button
          onClick={handleSignIn}
          disabled={busy || !configured}
          style={{
            all: "unset",
            cursor: busy || !configured ? "not-allowed" : "pointer",
            opacity: busy || !configured ? 0.5 : 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
            width: "100%",
            padding: "12px 16px",
            borderRadius: 10,
            background: "rgba(0,190,255,0.16)",
            boxShadow: "inset 0 0 0 1px rgba(0,190,255,0.45)",
            color: "#9CE7FF",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          <GoogleIcon />
          {busy ? "Signing in…" : "Sign in with Google"}
        </button>

        {(error || signInError) && (
          <div
            style={{
              marginTop: 14,
              padding: "10px 12px",
              borderRadius: 10,
              background: "rgba(255,15,0,0.10)",
              boxShadow: "inset 0 0 0 1px rgba(255,80,80,0.40)",
              color: "#FFB0AB",
              fontSize: 12.5,
            }}
          >
            {error || signInError}
          </div>
        )}
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
        fill="#4285F4"
      />
      <path
        d="M9 18c2.43 0 4.467-.806 5.956-2.185l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"
        fill="#34A853"
      />
      <path
        d="M3.964 10.706A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.038l3.007-2.332z"
        fill="#FBBC05"
      />
      <path
        d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z"
        fill="#EA4335"
      />
    </svg>
  );
}
